import { Pipe, PipeTransform } from '@angular/core';
import { utf8ByteCount } from '../utils/form.util';

@Pipe({
  name: 'numberOfBytes',
})
export class NumberOfBytesPipe implements PipeTransform {
  transform(inputString: string): number {
    return utf8ByteCount(inputString);
  }
}
